import React from 'react';
import { ReportTableBody } from '../../../../../types/RectificationReportsTypes';
import { useAppSelector } from '../../../../../../store/hooks';
import {
  cancelledLinesDataSelector,
  reportIsVisibleSelector,
} from '../../../../../../store/selectors/reportsSelectors';
import { EntityType } from '../../../../../../common/types/commonTypes';
import ViewPageLink from '../../../../../../common/components/view-page-link/ViewPageLink';
import { TruncateTooltip } from '../../../../../../common/components/truncate-tooltip/TruncateTooltip';
import Tr from '../../../../../../core/components/table-components/Tr';
import TdNew from '../../../../../../core/components/table-components/table-new/TdNew';
import EmptyTableSection from '../../../../../../core/components/table-components/EmptyTableSection';
import Tbody from '../../../../../../core/components/table-components/Tbody';

const CancelledLinesBody: React.FC<ReportTableBody> = ({ columnsLength }) => {
  const reportIsVisible = useAppSelector(reportIsVisibleSelector);
  const { items } = useAppSelector(cancelledLinesDataSelector);

  const hiddenKeys = ['customerId', 'entityId', 'entityType', 'partId'];
  const nowrapKeys = ['quantity', 'actionDate'];
  const truncateKeys = ['categoryName', 'partName', 'actionInitiator', 'reason'];

  const renderLink = (entity: EntityType, value: string | number | null, id: number) => (
    <ViewPageLink entityType={entity} entityId={id}>
      <TruncateTooltip value={value} table />
    </ViewPageLink>
  );

  const renderCellValue = (
    key: string,
    value: string | number | null,
    item: typeof items[0],
  ) => {
    if (key === 'customerName') return renderLink('Customer', value, item.customerId);
    if (key === 'partCode') return renderLink('Part', value, item.partId);
    if (key === 'entityNumber') return renderLink(item.entityType as EntityType, value, item.entityId);
    if (truncateKeys.includes(key)) return <TruncateTooltip value={value} table />;
    return value;
  };

  return (
    <Tbody>
      {items.length > 0
        ? items.map((el, i) => <Tr key={i}>
          {Object.entries(el).map(([key, value]) => {
            if (hiddenKeys.includes(key)) return null;
            return <TdNew key={key} nowrap={nowrapKeys.includes(key)}>
              {renderCellValue(key, value, el)}
            </TdNew>;
          })}
          <TdNew />
        </Tr>)
        : <EmptyTableSection text={reportIsVisible ? 'No data' : 'Please run a report'} colSpan={columnsLength + 1} />}
    </Tbody>
  );
};

export default CancelledLinesBody;
